import _inheritsLoose from '@babel/runtime/helpers/inheritsLoose';
import React, { useMemo, useCallback, Component } from 'react';
import PropTypes from 'prop-types';
import { mergeStyles, getRelValue, normalizeHref } from 'wix-rich-content-common';
import { S as Styles, A as ACTION_BUTTON_TYPE, L as LINK_BUTTON_TYPE, a as alignmentClassName, s as sizeClassName } from './viewer-loadable2.js';
import 'classnames';
import 'lodash';
import '@loadable/component';
import 'ricos-schema';
import 'ricos-types';

function _createForOfIteratorHelperLoose$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }
function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$1) {
    for (var _iterator = _createForOfIteratorHelperLoose$1(__getOwnPropSymbols$1(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
    }
  }
  return a;
};
var ButtonViewer = function ButtonViewer(_ref) {
  var style = _ref.style,
    anchorTarget = _ref.anchorTarget,
    onClick = _ref.onClick,
    theme = _ref.theme,
    helpers = _ref.helpers,
    url = _ref.url,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? anchorTarget : _ref$target,
    rel = _ref.rel,
    buttonText = _ref.buttonText;
  var styles = mergeStyles({
    styles: Styles,
    theme: theme
  });
  var isActionButton = useMemo(function () {
    return Boolean(onClick);
  }, [onClick]);
  var onClickHandler = useCallback(function (args) {
    var _a;
    (_a = helpers.onViewerAction) == null ? void 0 : _a.call(helpers, isActionButton ? ACTION_BUTTON_TYPE : LINK_BUTTON_TYPE, "Click", "");
    if (isActionButton) {
      onClick == null ? void 0 : onClick(args);
    }
  }, [helpers.onViewerAction]);
  var Component = isActionButton ? "div" : "a";
  return /* @__PURE__ */React.createElement(Component, __spreadValues$1({
    className: styles.button_container,
    style: style,
    "data-hook": "buttonViewer",
    onClick: onClickHandler,
    tabIndex: 0,
    role: "button",
    onKeyDown: function onKeyDown(e) {
      if (e.key === " " || e.key === "Enter") {
        e.preventDefault();
        onClickHandler(e);
      }
    }
  }, !isActionButton && {
    href: url,
    target: target,
    rel: getRelValue(rel)
  }), /* @__PURE__ */React.createElement("div", {
    className: styles.button_text
  }, buttonText));
};

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }
  return a;
};
var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var ButtonComponent = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ButtonComponent, _Component);
  function ButtonComponent() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = ButtonComponent.prototype;
  _proto.render = function render() {
    var _a, _b, _c, _d;
    var _this$props = this.props,
      button = _this$props.componentData.button,
      _this$props$settings = _this$props.settings,
      onClick = _this$props$settings.onClick,
      themeData = _this$props$settings.themeData,
      config = _this$props.config,
      helpers = _this$props.helpers,
      anchorTarget = _this$props.anchorTarget,
      theme = _this$props.theme;
    var _ref = themeData || (config == null ? void 0 : config.themeData) || {},
      _ref$colors = _ref.colors;
    _ref$colors = _ref$colors === void 0 ? {} : _ref$colors;
    var actionColor = _ref$colors.actionColor,
      bgColor = _ref$colors.bgColor;
    var buttonText = button.settings.buttonText;
    var url = (_a = button.settings) == null ? void 0 : _a.url;
    var linkButtonSettings = {};
    if (url) {
      linkButtonSettings = {
        url: normalizeHref(url),
        target: button.settings.target,
        rel: button.settings.rel
      };
    }
    var style = __spreadValues(__spreadValues({
      border: "0px solid blue",
      color: ((_b = this.props.settings.colors) == null ? void 0 : _b.color1) || bgColor,
      background: ((_c = this.props.settings.colors) == null ? void 0 : _c.color8) || actionColor,
      borderColor: ((_d = this.props.settings.colors) == null ? void 0 : _d.color8) || actionColor
    }, this.props.style), button.design);
    return /* @__PURE__ */React.createElement(ButtonViewer, __spreadValues({
      style: style,
      buttonText: buttonText,
      theme: theme,
      onClick: onClick,
      helpers: helpers,
      anchorTarget: anchorTarget
    }, linkButtonSettings));
  };
  return ButtonComponent;
}(Component);
__publicField(ButtonComponent, "alignmentClassName", function (componentData, theme, styles, isMobile) {
  return alignmentClassName(componentData, theme, styles);
});
__publicField(ButtonComponent, "sizeClassName", function (componentData, theme, styles, isMobile) {
  return sizeClassName(componentData, theme);
});
ButtonComponent.propTypes = {
  componentData: PropTypes.object,
  style: PropTypes.object,
  anchorTarget: PropTypes.string,
  settings: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  helpers: PropTypes.object,
  config: PropTypes.object
};

export { ButtonComponent as default };

import 'wix-rich-content-plugin-button/dist/loadable/viewer/es/styles.viewer.min.global.css'